import React, {useState} from 'react'
import Accordion from 'react-bootstrap/Accordion'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import {Form, InputGroup} from 'react-bootstrap'
import Spinner from 'react-bootstrap/Spinner'
import {GroupDetailsContext} from '../../../../context/Modal/GroupDetails'
import {AuditModalBarContext} from '../../../../context/AuditModalBar'
import {AuditModalApiContext} from '../../../../context/AuditModalApi'
import {withTranslation} from 'react-i18next'

import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import Typography from '@material-ui/core/Typography'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import search_icon from '../../../../assets/images/filter_search.svg'
import close_icon from '../../../../assets/images/filter_close.svg'

function CustomSelectFilters(props) {
  const [states, setStates] = useState({
    search: [props.filters],
    changeDefaultCaret: false,
  })

  const [query, setQuery] = useState(false)

  const {t} = props
  const [grandParentCaret, setGrandParentCaret] = React.useState(null)
  const AccordionElement = React.useRef(null)
  const {audit_entities_attributes, setGroupDetails} = React.useContext(GroupDetailsContext)
  const modalBar = React.useContext(AuditModalBarContext)
  const {getEntityFilterFields, getSearchFilterFields} = React.useContext(AuditModalApiContext)
  const [searchLoading, setSearchLoading] = React.useState(false)
  const entity_id = audit_entities_attributes[0].entity_id
  const searchInput = React.createRef()

  React.useEffect(() => {
    if (props.filters.length !== 0) {
      setStates({...states, search: props.filters})
    } else {
      if (states.changeDefaultCaret) {
        //AccordionElement.current.click()
      }
    }
    //eslint-disable-next-line
  }, [props.filters.length, entity_id])

  const handleSearchWithApis = e => {
    if ('Enter' === e.key) {
      e.preventDefault()
      if (e && e.target && e.target.value) {
        if (e.target.value && e.target.value !== '' && e.target.value.length >= 2) {
          setSearchLoading(true)
          let searchText = e.target.value

          getSearchFilterFields(audit_entities_attributes[0].entity_id, searchText).then(() => {
            setSearchLoading(false)
            setQuery(true)
            handleSearch(searchText)
          })
        }
      } else {
        setSearchLoading(true)
        let searchText = e.target.value

        getSearchFilterFields(audit_entities_attributes[0].entity_id, '').then(() => {
          setSearchLoading(false)
          setQuery(false)
          handleSearch(searchText)
        })
      }
    }
  }

  const handleSearchWithClick = () => {
    let searchText = searchInput && searchInput.current && searchInput.current.value
    if (searchText.length >= 3) {
      setSearchLoading(true)
      getSearchFilterFields(audit_entities_attributes[0].entity_id, searchText).then(() => {
        setSearchLoading(false)
        setQuery(true)
        handleSearch(searchText)
      })
    } else if (searchText === '') {
      setSearchLoading(true)
      getSearchFilterFields(audit_entities_attributes[0].entity_id, searchText).then(() => {
        setSearchLoading(false)
        setQuery(false)
        handleSearch(searchText)
      })
    }
  }

  const handleSearchClose = () => {
    let searchText = searchInput && searchInput.current && searchInput.current.value
    setSearchLoading(true)
    getSearchFilterFields(audit_entities_attributes[0].entity_id, '').then(() => {
      setSearchLoading(false)
      setQuery(false)
      handleSearch('')
    })
    searchInput.current.value = ''
  }
  const handleSearch = search => {
    setStates({...states, search: props.filters})
  }

  const removeDuplicates = (myArr, prop1, prop2) => {
    return myArr.filter((obj, pos, arr) => {
      return (
        arr.findIndex(mapObj => mapObj[prop1] === obj[prop1] && mapObj[prop2] === obj[prop2]) ===
        pos
      )
    })
  }

  const getFilters = (defaultArr, arr, obj, props1, props2, props3) => {
    let myArr = []
    let myArr2 = arr.filter(myObj => myObj[props1] + '' === obj[props2] + '')
    myArr2.map(c => {
      if (c.is_parent) {
        myArr = [...myArr, ...arr.filter(myObj => myObj[props1] + '' === c[props3] + '')]
      }
      return true
    })
    return [...defaultArr, ...myArr2, ...myArr]
  }

  const handleFilterCheckboxChange = (e, filter) => {
    let fieldArr = []
    let newArr = [...audit_entities_attributes]
    let filterObj = []
    let filterOpt = []
    let options = []

    if (e.target.checked) {
      if (filter.field_parent_id !== '') {
        filterObj = getFilters(
          filterObj,
          props.filters,
          filter,
          'field_id',
          'field_parent_id',
          'parent_id'
        )
      }

      filterObj.map(ff => {
        options = [...options, ...filedTypeOptionFilter(ff, true)]
        return true
      })

      if (filter.is_parent) {
        filterOpt = getFilters(filterOpt, options, filter, 'parent_id', 'value_id', 'value_id')
      }

      if (filter.parent_id !== '') {
        filterOpt = getFilters(filterOpt, options, filter, 'value_id', 'parent_id', 'parent_id')
      }

      fieldArr = removeDuplicates([...props.values, ...filterOpt, filter], 'value_id', 'field_id')
    } else {
      if (filter.field_is_parent) {
        filterObj = getFilters(
          filterObj,
          props.filters,
          filter,
          'parent_id',
          'field_id',
          'field_id'
        )
      }

      filterObj.map(ff => {
        options = [...options, ...filedTypeOptionFilter(ff, true)]
        return true
      })

      if (filter.is_parent) {
        filterOpt = getFilters(filterOpt, options, filter, 'parent_id', 'value_id', 'value_id')
      }

      let selectedFilter = props.values
      filterOpt.map(opt => {
        selectedFilter = selectedFilter.filter(
          myOpt => myOpt.value_id.toString() !== opt.value_id.toString()
        )
        return true
      })
      fieldArr = selectedFilter.filter(
        myOpt =>
          myOpt.value_id.toString() !== filter.value_id.toString() ||
          myOpt.field_id.toString() !== filter.field_id.toString()
      )
    }
    audit_entities_attributes[0].audit_entity_filters_attributes = fieldArr
    setGroupDetails(newArr)
  }

  const renderSelectedLabel = value => {
    const group = value.reduce((acc, cv) => {
      acc[cv.field_name] = [...(acc[cv.field_name] || []), cv]
      return acc
    }, {})
    if (Object.keys(group).length > 3) {
      return (
        <div className="css-1v99tuv">
          {Object.keys(group)
            .slice(0, 3)
            .map((key, index) => {
              return (
                <span key={index} className="selected-data">{`${key} (${group[key].length})`}</span>
              )
            })}
          <span className="selected-data-3">+{Object.keys(group).length - 3}</span>
        </div>
      )
    }
    return (
      <div className="css-1v99tuv">
        {Object.keys(group).map((key, index) => {
          return (
            <span key={index} className="selected-data">{`${key} (${group[key].length})`}</span>
          )
        })}
      </div>
    )
  }

  const changeCaret = () => {
    if (states.changeDefaultCaret === false) {
      if (props.filters.length === 0) {
        var selectedFilter = []
        props.values.forEach(function(item) {
          var existing = selectedFilter.filter(function(v, i) {
            return v.field_id === item.field_id
          })
          if (existing.length) {
            var existingIndex = selectedFilter.indexOf(existing[0])
            selectedFilter[existingIndex].values = selectedFilter[existingIndex].values.concat(
              item.values
            )
          } else {
            if (typeof item.values == 'string') item.values = [item.values]
            selectedFilter.push(item)
          }
        })
        getEntityFilterFields(audit_entities_attributes[0].entity_id, selectedFilter)
      }
      setStates({...states, changeDefaultCaret: true})
    } else {
      setStates({...states, changeDefaultCaret: false})
    }
  }

  const changeGrandparentCaret = value => {
    if (grandParentCaret === value) {
      setGrandParentCaret(1212441212121)
    } else {
      setGrandParentCaret(value)
    }
  }

  const filterCheckbox = (val, filter, isChecked, isArray, isMulti, isValue) => {
    let value_id = isArray ? (isMulti ? val[1].$oid.toString() : val[1]) : val
    let is_parent = false

    if (isMulti && filter.is_parent) {
      let childOpt = []
      let child = props.filters.filter(k => k.parent_id.toString() === filter.field_id.toString())
      child.map(p => {
        childOpt = [...childOpt, ...p.values]
        return true
      })
      let childFilterOpt = childOpt.filter(k => k[3]?.parent_id === value_id.toString())
      if (childFilterOpt.length > 0) {
        is_parent = true
      }
    }

    if (!isValue) {
      return (
        <Form.Check
          id={`${value_id}_${filter.field_id}`}
          type="checkbox"
          className="filter_ckeckbox"
          parent_id={isMulti && val[3] ? val[3].parent_id : ''}
          is_parent={is_parent}
          value_id={value_id}
          label={isArray ? val[0] : val}
          onClick={event => event.stopPropagation()}
          onChange={e => {
            handleFilterCheckboxChange(e, {
              field_id: filter.field_id,
              field_type: filter.field_type,
              field_name: filter.field_name,
              field_parent_id: filter.parent_id,
              field_is_parent: filter.is_parent,
              value_id: value_id,
              value_name: isArray ? val[0] : val,
              parent_id: isMulti && val[3] ? val[3].parent_id : '',
              is_parent: is_parent,
            })
            modalBar.setEditWarning(true)
          }}
          checked={isChecked}
        />
      )
    } else {
      return {
        field_id: filter.field_id,
        field_type: filter.field_type,
        field_name: filter.field_name,
        field_parent_id: filter.parent_id,
        field_is_parent: filter.is_parent,
        value_id: value_id,
        value_name: isArray ? val[0] : val,
        parent_id: isMulti && val[3] && val[3].parent_id,
        is_parent: is_parent,
      }
    }
  }

  const fieldTypeCheckbox = (filter, values, isArray, isMulti, isValue) => {
    let val = null
    let fieldTypeCheckboxOptionItem = values.map(item => {
      val = isArray ? (isMulti ? item[1].$oid.toString() : item[1]) : item
      let isChecked = false
      let data = props.values.filter(
        k => k.field_id === filter.field_id && k.value_id.toString() === val.toString()
      )
      if (data.length > 0) {
        isChecked = true
      }
      return filterCheckbox(item, filter, isChecked, isArray, isMulti, isValue)
    })
    return fieldTypeCheckboxOptionItem
  }

  const filedTypeOptionFilter = (filter, isValue = false) => {
    let options = []
    if (filter.field_type === 'StatusField') {
      options = fieldTypeCheckbox(filter, filter.values, true, false, isValue)
    } else if (
      filter.field_type === 'EntityListField' ||
      filter.field_type === 'MultipleEntityListField'
    ) {
      options = fieldTypeCheckbox(filter, filter.values, true, true, isValue)
    } else if (filter.field_type === 'ListField' || filter.field_type === 'MultipleListField') {
      options = fieldTypeCheckbox(filter, filter.values, false, false, isValue)
    } else {
      options = fieldTypeCheckbox(filter, filter.values, false, false, isValue)
    }
    return options
  }

  const getChildNestedData = (options, childOptions) => {
    if (options.length === 0) return null

    let newArr = options.map(opt => {
      if (opt.props.is_parent) {
        let filteredChildOption = childOptions.filter(k => k.props.parent_id !== null)
        if (filteredChildOption === '' || filteredChildOption === null) {
          return opt
        }
        let childFilterOption = filteredChildOption.filter(
          k => k.props.parent_id.toString() === opt.props.value_id.toString()
        )
        return (
          <ExpansionPanel className="childCaret">
            <ExpansionPanelSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={opt.props.value_id}
              id={opt.props.value_id}
            >
              <Typography>{opt}</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <div>
                {childFilterOption}
                {childFilterOption.length >= 25 ? (
                  <div style={{color: 'red'}}>
                    Load limit reached. <br /> Please use search for more results.
                  </div>
                ) : null}
              </div>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        )
      } else {
        return opt
      }
    })
    return newArr
  }

  const getParentNestedData = (filter, options) => {
    let newArr = []

    if (
      (!filter.is_parent && filter.parent_id !== '') ||
      (!filter.is_parent && filter.parent_id === '')
    ) {
      return options
    } else if (filter.is_parent && filter.parent_id === '') {
      let parentOption = []
      let childOption = []

      let parent = props.filters.filter(k => k.parent_id + '' === filter.field_id + '')
      parent.map(p => {
        if (p.is_parent) {
          let child = props.filters.filter(k => k.parent_id + '' === p.field_id + '')
          child.map(c => {
            childOption = [...childOption, ...filedTypeOptionFilter(c)]
            return true
          })
        }
        parentOption = [...parentOption, ...filedTypeOptionFilter(p)]
        return true
      })

      newArr = options.map(opt => {
        if (opt.props.is_parent) {
          let filteredChildOption = parentOption.filter(k => k.props.parent_id !== null)
          if (filteredChildOption === '' || filteredChildOption === null) {
            return opt
          }
          let parentFilterOption = filteredChildOption.filter(
            k => k.props.parent_id.toString() === opt.props.value_id.toString()
          )
          return (
            <div>
              <ExpansionPanel className="parentCaret">
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={opt.props.value_id}
                  id={opt.props.value_id}
                  //aria-controls="additional-actions1-content"
                >
                  {opt}
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <div style={{width: '100%'}}>
                    {getChildNestedData(parentFilterOption, childOption)}
                    {parentFilterOption.length >= 25 ? (
                      <div style={{color: 'red'}}>
                        Load limit reached. <br /> Please use search for more results.
                      </div>
                    ) : null}
                  </div>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            </div>
          )
        } else {
          return opt
        }
      })
    }
    return newArr
  }

  const getFieldNameLabel = filter => {
    let labelName = filter.field_name
    let parentName = null
    let childName = null

    if (filter.is_parent) {
      let parentField = props.filters.filter(
        myObj => myObj.parent_id.toString() === filter.field_id.toString()
      )
      parentField.map(parent => {
        parentName = parentName ? `${parentName}, ${parent.field_name}` : parent.field_name
        if (parent.is_parent) {
          let childField = props.filters.filter(
            myObj => myObj.parent_id.toString() === parent.field_id.toString()
          )
          childField.map(child => {
            childName = childName ? `${childName}, ${child.field_name}` : child.field_name
            return true
          })
        }
        return true
      })

      if (parentName) {
        labelName = `${labelName} / ${parentName}`
      }
      if (childName) {
        labelName = `${labelName} / ${childName}`
      }
    }

    return labelName
  }

  const getGrandParentRelation = () => {
    let selectboxes = props.filters.map(filter => {
      if (filter.values.length === 0) return null

      if (filter.parent_id === '' || filter.parent_id) {
        let options = filedTypeOptionFilter(filter)
        let caretCheck = grandParentCaret === filter.field_id ? true : false

        return (
          <Card className="inner_card">
            <Accordion.Toggle
              as={Button}
              variant=""
              eventKey={filter.field_id}
              onClick={() => changeGrandparentCaret(filter.field_id)}
            >
              {getFieldNameLabel(filter)}
              <svg
                className={`MuiSvgIcon-root ${caretCheck && 'open'}`}
                focusable="false"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"></path>
              </svg>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey={filter.field_id}>
              <div>
                {getParentNestedData(filter, options)}
                {options.length >= 50 ? (
                  <div style={{color: 'red'}}>
                    Load limit reached. <br /> Please use search for more results.
                  </div>
                ) : null}
              </div>
            </Accordion.Collapse>
          </Card>
        )
      }
      return true
    })
    return selectboxes
  }

  return (
    <Accordion
      defaultActiveKey="0"
      className={
        states.changeDefaultCaret
          ? 'collapsible_section overflow-auto box-shadow'
          : 'collapsible_section overflow-auto'
      }
    >
      <Card className="first_card">
        <Accordion.Toggle
          as={Button}
          variant=""
          ref={AccordionElement}
          onClick={() => changeCaret()}
          eventKey="001"
        >
          {props.values.length === 0
            ? t('audit.form-custom-select-filters.select-filter-field')
            : renderSelectedLabel(props.values)}
          <span className={states.changeDefaultCaret ? 'display_none' : 'display_block'}>
            <svg
              height="20"
              width="20"
              viewBox="0 0 20 20"
              aria-hidden="true"
              focusable="false"
              className="css-6q0nyr-Svg"
            >
              <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
            </svg>
          </span>
          <span className={states.changeDefaultCaret ? 'display_block' : 'display_none'}>
            <svg
              className="MuiSvgIcon-root cross"
              focusable="false"
              viewBox="-5 -3 30 30"
              aria-hidden="true"
              role="presentation"
            >
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
            </svg>
          </span>
        </Accordion.Toggle>
      </Card>
      <Accordion.Collapse style={{margin: 10, marginTop: 0, marginBottom: 0}} eventKey="001">
        <div>
          <InputGroup className="">
            <Form.Control
              type="text"
              placeholder="Search"
              ref={searchInput}
              className="audit__input audit__input--search"
              onKeyDown={e => handleSearchWithApis(e)}
            />
            <InputGroup.Append>
              {!query ? (
                <img
                  src={search_icon}
                  className="filter-search-image"
                  alt="img"
                  onClick={e => handleSearchWithClick(e)}
                ></img>
              ) : (
                <img
                  src={close_icon}
                  className="filter-search-image"
                  alt="img"
                  onClick={e => handleSearchClose(e)}
                ></img>
              )}
            </InputGroup.Append>
          </InputGroup>
          {!props.isFilterLoading ? (
            <Accordion defaultActiveKey={states.grandParentCaretValue} className="filter_height">
              <div>
                {props.filters.length ? (
                  getGrandParentRelation()
                ) : (
                  <div className="label">No results found!</div>
                )}
              </div>
            </Accordion>
          ) : (
            <div className="loader-height-37">
              <Spinner animation="border" role="status" />
            </div>
          )}
        </div>
      </Accordion.Collapse>
    </Accordion>
  )
}

export default withTranslation()(CustomSelectFilters)
